function LikesIcon(props?: any, width = '24', height = '24') {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M11.5996 5.62962L12 6.16475L12.4004 5.62962C13.3204 4.39983 14.7949 3.6001 16.44 3.6001C19.2315 3.6001 21.5 5.8739 21.5 8.6901C21.5 9.82572 21.3189 10.8738 21.0043 11.8462L21.0032 11.8494C20.249 14.2361 18.7035 16.1597 17.0354 17.5934C15.365 19.029 13.6004 19.9484 12.4589 20.3367L12.4589 20.3367L12.4536 20.3386C12.3537 20.3738 12.1893 20.4001 12 20.4001C11.8107 20.4001 11.6463 20.3738 11.5464 20.3386L11.5464 20.3386L11.5411 20.3367C10.3996 19.9484 8.635 19.029 6.96465 17.5934C5.29649 16.1597 3.75096 14.2361 2.99676 11.8494L2.99677 11.8494L2.99572 11.8462C2.68114 10.8738 2.5 9.82572 2.5 8.6901C2.5 5.8739 4.76848 3.6001 7.56 3.6001C9.2051 3.6001 10.6796 4.39983 11.5996 5.62962Z"
                fill="#E36966"
                stroke="#E36966"
            />
        </svg>
    );
}

export default LikesIcon;
